// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2nHhH","empty":"ModalGraph_empty__3uuSq"};